// src/contexts/UserContext.tsx
import React, { createContext, useReducer, ReactNode } from 'react'

// 定义用户状态
interface UserState {
  token: string | null
}

// 初始化状态
const initialState: UserState = {
  token: null
}

// 定义 action 类型
type UserAction =
  | { type: 'SET_TOKEN'; token: string }
  | { type: 'REMOVE_TOKEN' }

// 创建 reducer 来处理状态更新
const userReducer = (state: UserState, action: UserAction): UserState => {
  switch (action.type) {
    case 'SET_TOKEN':
      return { ...state, token: action.token }
    case 'REMOVE_TOKEN':
      return { ...state, token: null }
    default:
      return state
  }
}

// 创建 Context
export const UserContext = createContext<{ state: UserState; dispatch: React.Dispatch<UserAction> } | undefined>(undefined)

// 定义 UserProvider
interface UserProviderProps {
  children: ReactNode
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(userReducer, initialState)

  return (
    <UserContext.Provider value={{ state, dispatch }}>
      {children}
    </UserContext.Provider>
  )
}
